export enum Color {
  Blue = "Blue",
  Green = "Green",
  Lime = "Lime",
  Orange = "Orange",
  Red = "Red",
  Teal = "Teal",
  Gray = "Grey",
}
